"use client";
import { jsx } from "react/jsx-runtime";
import { useLucidWorks } from "../../../../hooks/useLucidWorks/index.js";
import { LucidWorksCarousel } from "./LucidWorksCarousel.js";
const CollectionCarousel = ({
  entry,
  locale,
  contextData,
  titleProps,
  isProductDetailsPage,
  maxSlides,
  productTileSx,
  carouselContainerSx,
  sx
}) => {
  const { collectionName, collectionSlug, pdpId } = contextData;
  const { itemIds: collectionItems = [] } = useLucidWorks(
    entry,
    "*:*",
    collectionSlug,
    locale
  );
  const { title = "", href = "" } = titleProps || {};
  const collectionTitleProps = {
    ...titleProps,
    href: collectionSlug ? href.replace("{{collectionSlug}}", collectionSlug) : null,
    title: collectionName ? title.replace("{{collectionName}}", collectionName) : null
  };
  const filteredCollectionItems = collectionItems.filter(
    (itemId) => String(itemId) !== String(pdpId)
  );
  return /* @__PURE__ */ jsx(
    LucidWorksCarousel,
    {
      entry,
      locale,
      titleProps: collectionTitleProps,
      isProductDetailsPage,
      maxSlides,
      productTileSx,
      carouselContainerSx,
      sx,
      itemIds: filteredCollectionItems
    }
  );
};
export {
  CollectionCarousel
};
